import { lazy, useEffect, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { Attachments, useNVModal } from '@nv/components'
import FileIcon from '@nv/images/design/file-icon'
import { AdminVoterAuthService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import styles from './AdminSFTP.module.scss'
const EventAttach = lazy(() => import('@nv/lazy-loadable/lib/modals/EventAttach'))

export const AdminSFTP = () => {
  const { t } = useTranslation()
  const [currentView] = useState('Add Document')
  const [listOfDocs, setListOfDocs] = useState([] as any)
  const { NVModal: UploadDocModal, openModal: openuploadDocModal } = useNVModal()

  const getSFTPUploads = async () => {
    try {
      const resp = await AdminVoterAuthService.getSFTPs()
      if (resp) setListOfDocs(resp)
    } catch (error) {
      //console.log(error)
    }
  }

  useEffect(() => {
    getSFTPUploads()
  }, [])

  const onSubmitUpload = async (formData, eventId = null) => {
    return await AdminVoterAuthService.createSFTP(formData)
  }

  return (
    <>
      <UploadDocModal>
        <EventAttach view={currentView} eventId={null} getAttachments={getSFTPUploads} onSubmitUpload={onSubmitUpload} />
      </UploadDocModal>

      <div className={styles['container']}>
        <div className={styles['header']}>
          <h1>{t('pages.sftp')}</h1>

          <NVButton
            variant='primaryGrey'
            text={t('uploads.document.add')}
            height={40}
            onClick={() => openuploadDocModal()}
            icon={<FileIcon color={'var(--primary-color)'} />}
          />
        </div>

        <Attachments listOfDocs={listOfDocs} getAttachments={getSFTPUploads} viewOnly={true} />
      </div>
    </>
  )
}
